/* eslint-disable import/prefer-default-export */
export function getPositioningClass({ inWebchat, senderType }) {
  let rv = 'webchat-item-right';
  if (inWebchat && senderType === 'customers') {
    rv = 'hidden';
  } else if (inWebchat && senderType === 'agents') {
    rv = 'webchat-item-left';
  } else if (!inWebchat && senderType === 'customers') {
    rv = 'webchat-item-left';
  }
  return rv;
}
